import React, {useState} from "react";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import EpmsImage from "../../../../Common/EpmsImage";
import Button from "@material-ui/core/Button";
import AppBar from "./AppBar";
import ImagePreview from "./ImagePreview";
import ToolbarContainer from "./ToolbarContainer";
import ActionsContainer from "./ActionsContainer";
import ToolbarContent from "./ToolbarContent";
import {Trans} from "react-i18next";


const useStyles = makeStyles(theme => ({
  mainContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  container: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: 'white',
    height: '148px',
    zIndex: '2'
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  formatButtonList: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    marginBottom: theme.spacing(2),
    overflow: 'auto',
    '& > li': {
      textAlign: 'center',
      marginLeft: theme.spacing(2)
    },
    '& h6': {
      fontSize: '16px',
      fontWeight: 'normal'
    }
  },
  filterButton: {
    width: '76px',
    height: '76px',
    border: '2px solid transparent',
    outline: 'none',
    padding: 0,
    '&.selected-filter, &:active, &:focus': {
      border: '2px solid ' + theme.palette.secondary.main
    }
  },
  imageFilter: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
}))

const ChangeFilter = ({setFilter, orderLine, onCancel}) => {
  const classes = useStyles();
  const [localFilter, setLocalFilter] = useState(() => {
    return orderLine.image.filter;
  });

  const handleSetFilter = (filter) => {
    setLocalFilter(filter);
  }

  return <div className={classes.mainContainer}>
    <AppBar onCancel={onCancel} />

    <ImagePreview orderLine={orderLine} overrideFilter={localFilter}/>

    <ToolbarContainer>
      <ToolbarContent>

        <ul className={classes.formatButtonList}>
        <li>
          <Typography variant="h6"><Trans>Original</Trans></Typography>
          <button className={`${classes.filterButton} ${localFilter == 'original' && 'selected-filter'}`} onClick={e => handleSetFilter('original')}>
            <EpmsImage uuid={orderLine.files[0].uuid} className={`${classes.imageFilter}`} effect="original" size={640} />
          </button>
        </li>
        <li>
          <Typography variant="h6"><Trans>Black/White</Trans></Typography>
          <button className={`${classes.filterButton} ${localFilter == 'bw' && 'selected-filter'}`} onClick={e => handleSetFilter('bw')}>
            <EpmsImage uuid={orderLine.files[0].uuid} className={`${classes.imageFilter}`} effect="bw" size={640}/>
          </button>
        </li>
        <li>
          <Typography variant="h6"><Trans>Sepia</Trans></Typography>
          <button className={`${classes.filterButton} ${localFilter == 'sepia' && 'selected-filter'}`} onClick={e => handleSetFilter('sepia')}>
            <EpmsImage uuid={orderLine.files[0].uuid} className={`${classes.imageFilter}`} effect="sepia" size={640} />
          </button>
        </li>
      </ul>
      </ToolbarContent>

      <ActionsContainer>
        <Button color="primary" onClick={onCancel}><Trans>Cancel</Trans></Button>
        <Button color="primary" onClick={() => setFilter(localFilter)}><Trans>Done</Trans></Button>
      </ActionsContainer>
    </ToolbarContainer>
  </div>
}

export default ChangeFilter;